import React from 'react'
import type { ReactNode } from 'react'

import * as S from './PricingTableCell.styled'

export interface TableCellProps {
  mainContent: ReactNode
  additionalContent?: ReactNode
}

export const PricingTableCell = ({ mainContent, additionalContent }: TableCellProps) => (
  <S.Container>
    <S.ContentContainer>
      <S.MainContent>{mainContent}</S.MainContent>
      {additionalContent && <S.AdditionalContent>{additionalContent}</S.AdditionalContent>}
    </S.ContentContainer>
  </S.Container>
)
